import { Component, Input } from '@angular/core';
import { CommonModule } from '@common/common.module';
import { GridCellContext, GridTemplateComponent } from '@common/interfaces/column-settings.interface';
import { InvoiceListModel } from 'app/invoice/models/invoice-list.model';

@Component({
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="flex items-center gap-2">
            <span>{{ invoiceNumber }}</span>
            @if (hasPdf) {
                <app-link [route]="['/invoice', 'view', invoiceId]" [queryParams]="{ tab: 2 }">
                    <ng-icon name="faSolidFilePdf" title="View PDF attachments"></ng-icon>
                </app-link>
            }
        </div>
    `
})
export class InvoiceNumberCellComponent implements GridTemplateComponent<InvoiceListModel> {
    context: GridCellContext<InvoiceListModel>;
    @Input() invoiceNumber: string;
    @Input() invoiceId: number;
    @Input() hasPdf: boolean;
}
